import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

export function registerReportMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('reports', locale)
}
